<template>
  <div class="channel-editor-wrap">
    <div class="px-table channel-editor">
      <header class="channel-editor-header">
        <h4>
          <span>Player</span>
          <span class="source-index">
            <span>{{index + 1}}</span>
          </span>
        </h4>
        <button v-if="removable" class="px-table-close" @click="removeChannel">
          <i class="close-small"/>
        </button>
      </header>
        <source-editor v-model="source" />
      <outputs-editor v-if="source && source.url"
                      ref="outputsPanel"
                      v-model="outputs"
                      :source="channel.source"/>
    </div>
  </div>
</template>

<script>
import { PxAWChannel } from '@pxflux/px-notation'
import OutputsEditor from './OutputsEditor'
import SourceEditor from './SourceEditor'

export default {
  name: 'channel-editor',
  components: { SourceEditor, OutputsEditor },
  props: {
    value: { type: [PxAWChannel, Object], required: true },
    channelId: { type: String, required: true },
    index: { type: Number, required: true },
    removable: Boolean
  },
  data () {
    return {
      channel: this.value || new PxAWChannel(),
      error: null
    }
  },
  computed: {
    source: {
      get () {
        return this.channel.source
      },
      set (newValue) {
        this.channel.source = newValue
        this.$emit('input', this.channel)
      }
    },
    outputs: {
      get () {
        return this.channel.outputs
      },
      set (newValue) {
        this.channel.outputs = newValue
        this.$emit('input', this.channel)
      }
    }
  },

  watch: {
    value (newValue) {
      this.channel = newValue || new PxAWChannel()
    }
  },

  methods: {
    removeChannel () {
      this.$emit('remove', this.index)
    },
    setChannel (channel) {
      this.$emit('input', channel)
    },
    fixPanelsOnScroll (e) {
      this.$refs['outputsPanel'].fixPanelsOnScroll(e)
    }
  }
}
</script>
<style lang="scss">
  @import "../../../../scss/vars";
  @import "../../../../scss/mixins";
  @import "../../../../scss/components/px-table";

  .channel-editor-wrap{
    flex-shrink: 0;
    flex-basis: 100%;
    width: 100%;
    max-width: $desc-max-width;
    margin-right: $basic-size;

    &:last-child{
      max-width: 100%;
      margin-right: 0;
    }

    .channel-editor {
      width: 100%;
      max-width: $desc-max-width;

      .channel-editor-header {
        h4 {
          display: flex;
          align-items: center;
        }
        .source-index {
          display: flex;
          align-items: center;
          justify-content: center;
          width: $basic-size / 2;
          height: $basic-size / 2;
          margin-left: $small-padding;
          border-radius: 50%;
          transition: all 0.15s;
        }
      }
    }

    &.active .channel-editor-header {
      h4 { color: $px-color-blue }
      .source-index {
        background: #fff;
        width: $two-thirds;
        height: $two-thirds;
      }
    }

    iframe {
      display: block;
    }
  }
</style>
